import type { MarketAnalysisPayload } from '@/services/api';
import { MarketAnalogAnalysisPanel } from './MarketAnalogAnalysisPanel';

export function MarketAnalysisReport({ analysis }: { analysis: MarketAnalysisPayload }) {
  return (
    <article className="market-analysis-report">
      <MarketAnalogAnalysisPanel analysis={analysis} />
    </article>
  );
}
